module.exports = __webpack_public_path__ + "img/logo.27f005d6.png";